/**
 * The registry of component initializers.
 */
const registry = {};
export default registry;
